export default "__VITE_ASSET__bb5eb9ee__"